import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AppShell from './components/AppShell';
import Login from './pages/Login';
import Markets from './pages/admin/Markets';
import Products from './pages/admin/Products';
import Users from './pages/admin/Users';
import MarketProducts from './pages/admin/MarketProducts';
import PackingAssignments from './pages/admin/PackingAssignments';
import Settings from './pages/admin/Settings';
import Reports from './pages/admin/Reports/Reports';
import Intercompany from './pages/admin/Intercompany';
import MarketDays from './pages/ops/MarketDays';
import MarketDayDetail from './pages/ops/MarketDayDetail';
import PackLists from './pages/ops/PackLists';
import PackListDetail from './pages/ops/PackListDetail';
import MarketPackSheet from './pages/ops/MarketPackSheet';
import KegTracker from './pages/ops/KegTracker';
import FarmStore from './pages/ops/FarmStore';
import ProductionLog from './pages/ops/ProductionLog/ProductionLog';
import ButcherLog from './pages/ops/ButcherLog/ButcherLog';
import MustardDip from './pages/ops/MustardDip/MustardDip';
import Payroll from './pages/ops/Payroll/Payroll';

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

function Unauthorized() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', fontFamily: 'sans-serif' }}>
      <div style={{ textAlign: 'center' }}>
        <h2 style={{ color: '#c0392b' }}>Access Denied</h2>
        <p style={{ color: '#666' }}>You do not have permission to view this page.</p>
        <a href="/login" style={{ color: '#2d5a27' }}>Back to login</a>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <GoogleOAuthProvider clientId={CLIENT_ID}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute roles={['admin']}>
                  <AppShell />
                </ProtectedRoute>
              }
            >
              <Route path="markets" element={<Markets />} />
              <Route path="products" element={<Products />} />
              <Route path="users" element={<Users />} />
              <Route path="market-products" element={<MarketProducts />} />
              <Route path="packing-assignments" element={<PackingAssignments />} />
              <Route path="intercompany" element={<Intercompany />} />
              <Route path="settings" element={<Settings />} />
              <Route path="reports" element={<Reports />} />
              <Route index element={<Navigate to="markets" replace />} />
            </Route>
            <Route
              path="/ops"
              element={
                <ProtectedRoute roles={['admin', 'manager', 'market_staff']}>
                  <AppShell />
                </ProtectedRoute>
              }
            >
              <Route path="market-days" element={<MarketDays />} />
              <Route path="market-days/:id" element={<MarketDayDetail />} />
              <Route path="pack-lists" element={<PackLists />} />
              <Route path="pack-lists/:id" element={<PackListDetail />} />
              <Route path="pack-lists/:id/market-sheets" element={<MarketPackSheet />} />
              <Route path="keg-tracker" element={<KegTracker />} />
              <Route path="farm-store" element={<FarmStore />} />
              <Route path="production-log" element={<ProductionLog />} />
              <Route path="butcher-log" element={<ButcherLog />} />
              <Route path="mustard-dip" element={<MustardDip />} />
              <Route path="payroll" element={<Payroll />} />
              <Route index element={<Navigate to="market-days" replace />} />
            </Route>
            <Route path="/" element={<Navigate to="/ops/market-days" replace />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}
